(() => {
  const materialsPoster = document.currentScript?.dataset.casekooMaterialsPoster;
  const thumbnailObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const button = entry.target;
          const thumbnail = button.dataset.casekooYoutubeThumbnail;
          if (thumbnail) button.style.backgroundImage = `url("${thumbnail}")`;
          observer.unobserve(button);
        });
      }, { rootMargin: '1000px 0px' })
    : null;

  const init = (scope = document) => {
    scope.querySelectorAll('[data-casekoo-article-media] iframe[data-casekoo-youtube-src]:not([data-casekoo-youtube-ready])').forEach((iframe) => {
      iframe.dataset.casekooYoutubeReady = 'true';
      const source = iframe.dataset.casekooYoutubeSrc;
      const match = source.match(/\/embed\/([^?&/]+)/);
      const videoId = match ? match[1] : '';
      const sourceWidth = Number.parseFloat(iframe.getAttribute('width'));
      const sourceHeight = Number.parseFloat(iframe.getAttribute('height'));
      const aspectRatio = sourceWidth > 0 && sourceHeight > 0 ? `${sourceWidth} / ${sourceHeight}` : '16 / 9';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'casekoo-youtube-facade';
      button.setAttribute('aria-label', iframe.title ? `Play video: ${iframe.title}` : 'Play video');
      button.style.aspectRatio = aspectRatio;
      if (videoId) button.dataset.casekooYoutubeThumbnail = videoId === 'DefLoGyPAPA' && materialsPoster
        ? materialsPoster
        : `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
      button.innerHTML = '<span class="casekoo-youtube-facade__play" aria-hidden="true"></span>';
      iframe.replaceWith(button);

      if (button.dataset.casekooYoutubeThumbnail) {
        if (thumbnailObserver) thumbnailObserver.observe(button);
        else button.style.backgroundImage = `url("${button.dataset.casekooYoutubeThumbnail}")`;
      }

      button.addEventListener('click', () => {
        if (thumbnailObserver) thumbnailObserver.unobserve(button);
        const separator = source.includes('?') ? '&' : '?';
        iframe.src = source + separator + 'autoplay=1';
        iframe.style.display = 'block';
        iframe.style.width = '100%';
        iframe.style.height = 'auto';
        iframe.style.aspectRatio = aspectRatio;
        iframe.setAttribute('width', '100%');
        iframe.removeAttribute('height');
        button.replaceWith(iframe);
      }, { once: true });
    });
  };

  const style = document.createElement('style');
  style.textContent = '.casekoo-youtube-facade{position:relative;display:block;width:100%;aspect-ratio:16/9;border:0;border-radius:12px;background-color:#111;background-size:cover;background-position:center;cursor:pointer}.casekoo-youtube-facade::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,transparent,rgba(0,0,0,.18))}.casekoo-youtube-facade__play{position:absolute;z-index:1;top:50%;left:50%;width:68px;height:48px;transform:translate(-50%,-50%);border-radius:14px;background:#ff0033;box-shadow:0 8px 24px rgba(0,0,0,.28)}.casekoo-youtube-facade__play::after{content:"";position:absolute;top:50%;left:53%;transform:translate(-50%,-50%);border-top:10px solid transparent;border-bottom:10px solid transparent;border-left:16px solid #fff}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
